import { OutputBlockData } from '@editorjs/editorjs';

import { parseImage } from './image';
import { extractCleanText } from './utils';

export const parseParagraph = (element: Element): OutputBlockData[] => {
  const blocks: OutputBlockData[] = [];
  const imgs = element.querySelectorAll('img');

  if (imgs.length === 0) {
    const cleanText = extractCleanText(element);
    if (cleanText) {
      blocks.push({
        type: 'paragraph',
        data: { text: cleanText },
      });
    }
    return blocks;
  }

  if (element.textContent?.trim() === '') {
    imgs.forEach(img => {
      blocks.push(...parseImage(img));
    });
    return blocks;
  }

  const clone = element.cloneNode(true) as Element;
  imgs.forEach(img => {
    blocks.push(...parseImage(img));
  });

  clone.querySelectorAll('img').forEach(img => {
    const parent = img.parentElement;
    img.remove();
    if (parent && parent.children.length === 0 && !parent.textContent?.trim()) {
      parent.remove();
    }
  });

  const cleanText = extractCleanText(clone);
  if (cleanText) {
    blocks.push({
      type: 'paragraph',
      data: { text: cleanText },
    });
  }

  return blocks;
};
